import { render, staticRenderFns } from "./weChat.vue?vue&type=template&id=424548af&scoped=true"
import script from "./weChat.vue?vue&type=script&lang=js"
export * from "./weChat.vue?vue&type=script&lang=js"
import style0 from "./weChat.vue?vue&type=style&index=0&id=424548af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424548af",
  null
  
)

export default component.exports